/*
*   ~ Project event keys go in here ~
*
*   Usage in components:
*
*   import Events from '@vaersaagod/tools/Events';
*   import * as eventKeys from '../lib/events';
*   Events.publish(eventKeys.SOME_EVENT, 'This ES6 shit is wack');
*
 */

export const USER_PREFERENCES_UPDATED = 'USER_PREFERENCES_UPDATED';
export const DOM_UPDATED = 'DOM_UPDATED';
export const MENU_OPEN = 'MENU_OPEN';
export const FILTER_UPDATED = 'FILTER_UPDATED';
export const FILTER_OPENED = 'FILTER_OPENED';

